var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Children, isValidElement } from 'react';
import { Loading, Toolbar } from 'react-admin';
import { Box } from '@mui/material';
import get from 'lodash/get';
import { useAuthorizedChildren, } from '../useAuthorizedChildren';
export var AccordionFormView = function (_a) {
    var _b = _a.authorizationError, authorizationError = _b === void 0 ? null : _b, _c = _a.autoClose, autoClose = _c === void 0 ? false : _c, children = _a.children, className = _a.className, _d = _a.enableAccessControl, enableAccessControl = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? DefaultLoading : _e, resource = _a.resource, _f = _a.toolbar, toolbar = _f === void 0 ? DefaultToolbar : _f, sx = _a.sx;
    var childrenArray = Children.toArray(children);
    var _g = useAuthorizedChildren({
        children: children,
        action: 'write',
        getResourceKey: getResourceKey,
        filterChildren: filterChildren,
        enabled: enableAccessControl,
    }), authorizedChildren = _g.authorizedChildren, isPending = _g.isPending, error = _g.error;
    var firstPanel = childrenArray.length > 0
        ? childrenArray[0]
        : null;
    if (!isValidElement(firstPanel)) {
        throw new Error('AccordionForm must only contain AccordionForm.Panel elements');
    }
    var firstPanelId = (firstPanel === null || firstPanel === void 0 ? void 0 : firstPanel.props.id)
        ? firstPanel.props.id
        : typeof firstPanel.props.label === 'string'
            ? firstPanel.props.label
            : null;
    var _h = React.useState(firstPanelId !== null && firstPanelId !== void 0 ? firstPanelId : false), expanded = _h[0], setExpanded = _h[1];
    var handleChange = function (panel) {
        return function (event, isExpanded) {
            setExpanded(isExpanded ? panel : false);
        };
    };
    if (error) {
        return authorizationError;
    }
    if (enableAccessControl && isPending) {
        return loading;
    }
    return (_jsxs(Box, { className: className, sx: sx, children: [_jsx("div", { children: Children.map(authorizedChildren, function (accordionPanel) {
                    var _a;
                    return React.isValidElement(accordionPanel)
                        ? React.cloneElement(accordionPanel, {
                            autoClose: autoClose,
                            expanded: expanded ===
                                (accordionPanel.props.id
                                    ? accordionPanel.props.id
                                    : accordionPanel.props.label),
                            onChange: handleChange(accordionPanel.props.id
                                ? accordionPanel.props.id
                                : accordionPanel.props.label.toString()),
                            resource: resource,
                            enableAccessControl: (_a = accordionPanel.props
                                .enableAccessControl) !== null && _a !== void 0 ? _a : enableAccessControl,
                        })
                        : null;
                }) }), toolbar] }));
};
var DefaultToolbar = _jsx(Toolbar, { sx: { backgroundColor: 'transparent' } });
var DefaultLoading = _jsx(Loading, {});
var getResourceKey = function (child, resource) {
    var _a;
    return "".concat(resource, ".section.").concat((_a = child.props.id) !== null && _a !== void 0 ? _a : child.props.label);
};
var filterChildren = function (child) {
    if (child.props.id == null && child.props.label == null) {
        if (process.env.NODE_ENV === 'development') {
            console.warn("You enabled access control on the AccordionForm but didn't provide an id nor a label to its panels. Access control cannot be enforced on some panels.");
        }
        return false;
    }
    return true;
};
export var findAccordionsWithErrors = function (children, errors) {
    return Children.toArray(children).reduce(function (acc, child) {
        if (!isValidElement(child)) {
            return acc;
        }
        var childAsElement = child;
        var inputs = Children.toArray(childAsElement.props.children);
        if (inputs.some(function (input) {
            return isValidElement(input) &&
                get(errors, input.props.source);
        })) {
            return __spreadArray(__spreadArray([], acc, true), [childAsElement.props.label], false);
        }
        return acc;
    }, []);
};
